import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=4f1d3824&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=js&"
export * from "./AdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d3824",
  null
  
)

export default component.exports